import { useEffect, useCallback } from 'react';

import styled from 'styled-components';
import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import SliderDefault from 'components/slider/SliderDefault';

import { ReactComponent as IconRemove } from 'asserts/icons/ic_x_white.svg';

interface ViewerProps {
  onClose: () => void;
  selectedTitle: string;
  selectedItem: string[] | string;
  type: 'image' | 'video';
}

const Viewer = ({ onClose, selectedTitle, selectedItem, type }: ViewerProps) => {
  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress, { passive: true });

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <Wrappaer>
      <CloseAWrapper onClick={onClose}>
        <IconRemove />
      </CloseAWrapper>
      <InnerWrapper>
        {type === 'image' ? (
          <SliderWrapper>
            {Array.isArray(selectedItem) ? (
              <SliderDefault imgs={selectedItem} />
            ) : selectedItem.endsWith('.pdf') ? (
              <embed
                src={selectedItem}
                type="application/pdf"
                aria-label="pdf image"
                width="100%"
              ></embed>
            ) : (
              <img className="image" src={selectedItem} alt="이미지 상세" />
            )}
            <h3>{selectedTitle}</h3>
          </SliderWrapper>
        ) : (
          <VideoWrapper>
            <video muted autoPlay controls width="1280" height="auto">
              <source src={selectedItem.toString()} type="video/mp4" />
            </video>
          </VideoWrapper>
        )}
      </InnerWrapper>
    </Wrappaer>
  );
};

export default Viewer;

const Wrappaer = styled.div`
  gap: 64px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${color.black2};
  z-index: 200;
  padding: 0 24px;
`;

const CloseAWrapper = styled.p`
  position: absolute;
  top: 26px;
  right: 24px;
  width: 32px;
  height: 32px;
  margin-left: auto;
  z-index: 300;
  cursor: pointer;
`;

const InnerWrapper = styled.div`
  position: relative;
  color: ${color.white};
  ${font.h3_medium};

  img,
  embed {
    height: 100vh;
    object-fit: contain;
  }

  h3 {
    position: absolute;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    display: inline-flex;
    padding: 8px 16px;
    align-items: center;
    border-radius: 24px;
    background: ${color.opacityBlack07};
    color: ${color.white2} ${font.body_medium};

    z-index: 300;
  }
`;

const SliderWrapper = styled.div`
  img.image {
    width: 100%;
  }
`;

const VideoWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
`;
